import { Component, OnInit, ViewChild } from '@angular/core';
import { VendaPergunta } from 'src/app/models/venda-pergunta';
import { Filtro } from 'src/app/models/filtro';
import { MatPaginator, MatDialog, MatDialogRef, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CadastrarQuestionarioEntregaModalComponent } from '../cadastrar-questionario-entrega-modal/cadastrar-questionario-entrega-modal.component';
import { QuestionarioService } from 'src/app/services/questionario.service';
import { PaginatorService } from 'src/app/services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-questionario-entrega-modal',
  templateUrl: './questionario-entrega-modal.component.html',
  styleUrls: ['./questionario-entrega-modal.component.scss']
})
export class QuestionarioEntregaModalComponent implements OnInit {
  perguntasFiltradas: VendaPergunta[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descri', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  tipoQuest = [{ descricao: 'CIF', valor: 0 }, { descricao: 'FOB', valor: 1}];
  tipoQuestSel = 0;
  tipoStatus = [
    { id: -1, descricao: 'Todos'},
    { id: 1, descricao: 'Ativo' },
    { id: 0, descricao: 'Bloqueado' }
  ];
  tipoStatusSelecionado = 1;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<QuestionarioEntregaModalComponent>,
    private questionarioService: QuestionarioService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPerguntas();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPerguntas();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPerguntas();
  }

  salvarPergunta(pergunta: VendaPergunta) {
    this.carregandoService.mostra('salvarPergunta');

    this.questionarioService.salvar(pergunta).subscribe(
      () => {
        this.buscarPerguntas();
        this.carregandoService.esconde('salvarPergunta');
      },
      err => {
        this.carregandoService.esconde('salvarPergunta');
        this.notificacaoService.erro(err);
      }
    )
  }

  excluirPergunta(pergunta: VendaPergunta) {
    this.carregandoService.mostra('excluirPergunta');

    this.questionarioService.excluir(pergunta.id).subscribe(
      () => {
        this.buscarPerguntas();
        this.carregandoService.esconde('excluirPergunta');
      },
      err => {
        this.carregandoService.esconde('excluirPergunta');
        this.notificacaoService.erro(err);
      }
    )
  }

  buscarPerguntas() {
    this.carregandoService.mostra('buscarPerguntas');

    this.questionarioService.consultarComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.tipoQuestSel, this.tipoStatusSelecionado).subscribe(
      (dados) => {
        this.perguntasFiltradas = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregandoService.esconde('buscarPerguntas');
      }
      , err => {
        this.carregandoService.esconde('buscarPerguntas');
        this.notificacaoService.erro(err);
      }
    );
  }

  novaPergunta() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarQuestionarioEntregaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      res.tipoQuest = this.tipoQuestSel;
      this.salvarPergunta(res);
    });
  }

  editarPergunta(pergunta: VendaPergunta) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarQuestionarioEntregaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { pergunta },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.salvarPergunta(res);
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
